import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import {
  gotoRegister,
  gotoLogin,
  gotoConsole,
  userLogout,
  tryNow,
} from "../../utils";
import { useForm } from "react-hook-form";
import classnames from "classnames";
import Axios from "axios";
import { phoneHuiju } from "../../utils/huijuApi";

export const TryOn = (props) => {
  const { style } = props;
  const { t } = useTranslation();
  const { handleSubmit, register, errors } = useForm();

  const isExistUser = async (phone) => {
    const { consoleHost, userPoolId } = window._AUTHING__GLOBAL_CONFIG_;

    try {
      // 查询一下用户是否存在
      const res = await Axios.get(`${consoleHost}/api/v2/users/find`, {
        params: {
          userPoolId: userPoolId,
          key: phone,
          type: "phone",
        },
      });
      return res.data.data;
    } catch (error) {
      return false;
    }
  };

  const onSubmit = async (values) => {
    const currentPhone = values.phone;
    // const user = window?.__user__;
    phoneHuiju(currentPhone);
    tryNow(currentPhone);
    // if (user) {
    //   // 当前有登录用户，并且当前登录用户的手机号与当前输入的手机号一致
    //   if (currentPhone === user?.phone_number) {
    //     gotoConsole();

    //     return;
    //   }

    //   // 并且当前登录用户的手机号与当前输入的手机号不一致
    //   // 退出当前用户
    //   await userLogout();
    // }

    // const isExist = await isExistUser(currentPhone);

    // if (isExist) {
    //   // 用户存在, 跳转到登录页面
    //   gotoLogin(currentPhone);
    // } else {
    //   // 用户不存在, 跳转到注册页面
    //   gotoRegister(currentPhone);
    // }
  };
  const onError = (errors, e) => {
    console.log(errors);
  };
  return (
    <div className="try-on" style={style ? style : {}}>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <input
          name="phone"
          placeholder={t("common.input-placeholder")}
          ref={register({
            required: true,
            pattern: {
              value: /^1[3-9]\d{9}$/,
              message: "error message", // JS only: <p>error message</p> TS only support string
            },
          })}
          className={classnames({ error: errors.phone })}
        />
        <button type="submit" className="try-on-button">
          {t("common.try-on")}
        </button>
      </form>
    </div>
  );
};
